export default __webpack_public_path__ + "banner-framework-abd7da37.png";